import { BaseEntity } from 'src/app/entities/base-entity/base-entity';

/**
 * Class that represents a client in the tracking system.
 *
 * @class client
 */
export class Client extends BaseEntity {
  /**
   * Creates an instance of a client.
   */
  constructor(
    _uuid: string,
    protected _name: string,
  ) {
    super(_uuid);
  }

  get name(): string {
    return this._name;
  }
}
